import {createReducer} from '../../../utils/reducer';
import Esnap from '../actions/Esnap';

export default createReducer(null, {
    [Esnap.update]: (state, data) => {
      return {events: data};
    }
});



// WEBPACK FOOTER //
// ./scripts/frontend/base/reducer/esnap.js